module.exports = __webpack_public_path__ + "static/media/sweet_view_4.7e0dcb60.jpg";